import {
  InventorySupplierRecord,
  SaveInventorySupplierRequest,
} from '@/renderer/types/inventory';

export interface InventorySupplierFormState {
  name: string;
  contactPerson: string;
  phone: string;
  email: string;
  taxId: string;
  address: string;
  paymentTermsDays: string;
  openingBalance: string;
  isActive: boolean;
}

export const createEmptyInventorySupplierForm =
  (): InventorySupplierFormState => ({
    name: '',
    contactPerson: '',
    phone: '',
    email: '',
    taxId: '',
    address: '',
    paymentTermsDays: '0',
    openingBalance: '0',
    isActive: true,
  });

export const createInventorySupplierFormFromRecord = (
  record: InventorySupplierRecord,
): InventorySupplierFormState => ({
  name: record.name,
  contactPerson: record.contact_person ?? '',
  phone: record.phone ?? '',
  email: record.email ?? '',
  taxId: record.tax_id ?? '',
  address: record.address ?? '',
  paymentTermsDays: String(record.payment_terms_days),
  openingBalance: String(record.opening_balance),
  isActive: record.is_active,
});

export const buildSaveInventorySupplierPayload = (
  companyId: number,
  form: InventorySupplierFormState,
  id?: string,
): SaveInventorySupplierRequest => ({
  id,
  companyId,
  name: form.name,
  contactPerson: form.contactPerson || null,
  phone: form.phone || null,
  email: form.email || null,
  taxId: form.taxId || null,
  address: form.address || null,
  paymentTermsDays: Number(form.paymentTermsDays || 0),
  openingBalance: Number(form.openingBalance || 0),
  isActive: form.isActive,
});
